export default __webpack_public_path__ + "static/kamifuusen_blue-d08920201ce7bb02f2bbeaf225d18b60.jpg";